import { CollectionEntity } from "@busy-human/gearbox";
import { z } from "zod";
export var Flights;
(function (Flights) {
    Flights.ModelSchema = z.object({
        additionalInformation: z.string().nullable().default(null),
        airportMeetupInstructions: z.string().nullable().default(null),
        airline: z.string().nullable().default(null),
        airport: z.string().nullable().default(null),
        airportMapLink: z.string().nullable().default(null),
        baggageInfo: z.string().nullable().default(null),
        endTime: z.string().datetime().nullable().default(null),
        flightChangeDate: z.string().datetime().nullable().default(null),
        lastDataFetchedDate: z.string().datetime().nullish().default(null),
        name: z.string().default(""),
        flightNumber: z.string().nullable().default(null),
        flightPublishDate: z.string().datetime().nullable().default(null),
        flightType: z.union([z.literal('Departure'), z.literal('Return'), z.literal('Internal')]).nullable().default(null),
        landing: z.string().datetime().nullable().default(null),
        landingGate: z.string().nullish().default(null),
        landingTerminal: z.string().nullish().default(null),
        landingAirportTimeZone: z.string().nullable().default(null),
        majorFlightChange: z.boolean().default(false),
        minorFlightChange: z.boolean().default(false),
        investigateFlightChange: z.boolean().default(false),
        overnight: z.boolean().default(false),
        startTime: z.string().datetime().nullable().default(null),
        takeoff: z.string().datetime().nullable().default(null),
        takeoffGate: z.string().nullish().default(null),
        takeoffTerminal: z.string().nullish().default(null),
        takeoffAirportTimezone: z.string().nullable().default(null),
        trip: z.string().nullable().default(null),
        originalTakeoff: z.string().datetime().nullish().default(null),
        originalLanding: z.string().datetime().nullish().default(null),
        skipFlightCheck: z.boolean().nullish().default(null),
        lastUpdated: z.string().datetime().nullish(),
        faAlertId: z.string().nullish()
    }).default({});
    function Default() {
        return Flights.ModelSchema.parse({});
    }
    Flights.Default = Default;
    function Validate(obj) {
        return Flights.ModelSchema.parse(obj);
    }
    Flights.Validate = Validate;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults = Default;
    }
    Flights.CollectionClass = CollectionClass;
    Flights.Collection = new CollectionClass({ path: "/Flights" });
})(Flights || (Flights = {}));
//# sourceMappingURL=index.js.map